import React, { useRef, useState, useEffect } from "react";
import { Play, Pause } from "lucide-react";

export const AudioPlayer = ({ src, compact = false, accent = "#0047AB" }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    const onTime = () => setProgress(a.duration ? (a.currentTime / a.duration) * 100 : 0);
    const onEnd = () => { setPlaying(false); setProgress(0); };
    a.addEventListener("timeupdate", onTime);
    a.addEventListener("ended", onEnd);
    return () => { a.removeEventListener("timeupdate", onTime); a.removeEventListener("ended", onEnd); };
  }, []);

  const toggle = (e) => {
    e?.preventDefault?.(); e?.stopPropagation?.();
    const a = audioRef.current;
    if (!a) return;
    // pause others
    document.querySelectorAll("audio").forEach((el) => { if (el !== a) el.pause(); });
    if (a.paused) { a.play(); setPlaying(true); } else { a.pause(); setPlaying(false); }
  };

  if (!src) return null;

  if (compact) {
    return (
      <button onClick={toggle} data-testid="audio-play-compact"
        className="w-10 h-10 flex items-center justify-center text-white shadow-lg transition-transform hover:scale-110"
        style={{ background: accent }} aria-label="Preview">
        {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4 ml-0.5" />}
        <audio ref={audioRef} src={src} preload="none" />
      </button>
    );
  }

  return (
    <div className="flex items-center gap-3 border border-neutral-200 p-3" data-testid="audio-player">
      <button onClick={toggle} data-testid="audio-play" className="w-11 h-11 shrink-0 flex items-center justify-center text-white transition-transform hover:scale-105" style={{ background: accent }}>
        {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
      </button>
      <div className="flex-1">
        <div className="flex items-center justify-between mb-1.5"><span className="label-caps">Audio preview</span><span className="text-xs text-neutral-400">{playing ? "Playing" : "Tap to play"}</span></div>
        <div className="h-1.5 bg-neutral-200 w-full"><div className="h-full transition-all" style={{ width: `${progress}%`, background: accent }} /></div>
      </div>
      <audio ref={audioRef} src={src} preload="none" />
    </div>
  );
};
